import styled from "styled-components/macro";

export const BackDropContainer = styled.div`
    width: 100%;
    height: 100%;
    backdrop-filter: ${props => (props.theme.sideMenu.blur ? "blur(5px)" : "none")};
    max-height: 100%;
    z-index: 3;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    overflow: hidden;
    flex-direction: column;
`;
